import React, { useEffect, useState } from 'react';
import './_RESensor.scss';
import { useTranslation } from 'react-i18next';
import UiIntegrater from '../../historyRecord/littleUIComponent/UiIntegrater';
import REDropdown from '../REDropdown/REDropdown';
import ApiGo from '../../../../actions/ApiGo';
import { useDispatch } from 'react-redux';
import { ADD_RESIDENTS_ARRAY } from '../../../../stores/reducer_residentsArray';
import PopConfirm from '../../../popUp/PopConfirm';
import ConfigHandler from '../../../../actions/ConfigHandler';
import { ADD_BEDS_ARRAY } from '../../../../stores/reducer_beds';

const RESensor = (props) => {
  const p = props.data;
  // i18n翻譯
  const { t } = useTranslation();
  const isVital = ConfigHandler.isVital;
  const isFdaClass = ConfigHandler.isFdaClass;
  // 三班制
  const [day_start, setDay_start] = useState();
  const [mid_start, setMid_start] = useState();
  const [night_start, setNight_start] = useState();

  // 選單呈現的數值
  const [lev_over, setLev_over] = useState(p !== undefined ? p.lev_over : 120); // 離床過久 "leaving_overtime": 120,
  const [leave_from, setLeave_from] = useState(p !== undefined ? p.leave_from : '22:00:00'); // 離床時段-起 "leaving_overtime_from_time": 22:00:00,
  const [leave_end, setLeave_end] = useState(p !== undefined ? p.leave_end : '07:00:00'); // 離床時段-終  "leaving_overtime_to_time": 0,
  const [long_sty, setLong_sty] = useState(p !== undefined ? p.long_sty : 120); // 久臥警示 "long_stay": 37,
  const [breath_high, setBreath_high] = useState(p !== undefined ? p.breath_high : 32); // 呼吸高於 "breath_high": 30,
  const [breath_low, setBreath_low] = useState(p !== undefined ? p.breath_low : 10); // 呼吸低於 "breath_low": 14,
  const [heart_high, setHeart_high] = useState(p !== undefined ? p.heart_high : 85);
  const [heart_low, setHeart_low] = useState(p !== undefined ? p.heart_low : 50);
  const [day_period, setDay_period] = useState(); // 日班 alert_level_day
  const [night_period, setNight_period] = useState(); // 小夜 alert_level_mid
  const [midnight_period, setMidnight_period] = useState(); // 大夜 alert_level_night
  const [long_sty_autotime, setLong_sty_autotime] = useState(); // k值連動: 久臥翻身時間
  const [voiceWarning, setVoiceWarning] = useState(); // 語音警告時間

  // 設定開、關
  const [lev_overSwitch, setLev_overSwitch] = useState(false);
  const [leave_fromSwitch, setLeave_fromSwitch] = useState(false);
  const [leave_endSwitch, setLeave_endSwitch] = useState(false);
  const [long_stySwitch, setLong_stySwitch] = useState(false);
  const [breath_highSwitch, setBreath_highSwitch] = useState(false);
  const [breath_lowSwitch, setBreath_lowSwitch] = useState(false);
  const [heart_highSwitch, setHeart_highSwitch] = useState(false);
  const [heart_lowSwitch, setHeart_lowSwitch] = useState(false);
  const [day_periodSwitch, setDay_periodSwitch] = useState(false);
  const [night_periodSwitch, setNight_periodSwitch] = useState(false);
  const [midnight_periodSwitch, setMidnight_periodSwitch] = useState(false);
  const [voiceWarningSwitch, setVoiceWarningSwitch] = useState(false);
  const [showVoiceWarning, setShowVoiceWarning] = useState(false); // 顯示語音警告選單

  // redux
  const dispatch = useDispatch();

  // 開、關的按鈕
  function SwitchFunction(num) {
    switch (num) {
      case 0:
        setLev_overSwitch(!lev_overSwitch);
        break;
      case 1:
        setLeave_fromSwitch(!leave_fromSwitch);
        break;
      case 2:
        setLeave_endSwitch(!leave_endSwitch);
        break;
      case 3:
        setLong_stySwitch(!long_stySwitch);
        break;
      case 4:
        setBreath_highSwitch(!breath_highSwitch);
        break;
      case 5:
        setBreath_lowSwitch(!breath_lowSwitch);
        break;
      case 6:
        setDay_periodSwitch(!day_periodSwitch);
        break;
      case 7:
        setNight_periodSwitch(!night_periodSwitch);
        break;
      case 8:
        setMidnight_periodSwitch(!midnight_periodSwitch);
        break;
      case 9:
        setHeart_highSwitch(!heart_highSwitch);
        break;
      case 10:
        setHeart_lowSwitch(!heart_lowSwitch);
        break;
      case 11:
        setVoiceWarningSwitch(!voiceWarningSwitch);
        break;
      default:
        return null;
    }
  }

  // 設定dropdown list，一共有四總範圍，因此設定用四組useState來接收這些數值
  const [arrbreath_high, setArrbreath_high] = useState([]);
  const [arrbreath_low, setArrbreath_low] = useState([]);
  const [arrHeart_high, setArrHeart_high] = useState([]);
  const [arrHeart_low, setArrHeart_low] = useState([]);
  const [arrlev_over, setArrlev_over] = useState([]);
  const [arrlong_sty, setArrlong_sty] = useState([]);
  const [arrrepeat, setArrrepeat] = useState([]);
  const [arrsit_up, setArrsit_up] = useState([]);
  // 建立迴圈模組 createArray(起始數值，目標數值，間隔，state，setState)
  const createArray = (init, final, num, state, setState) => {
    for (let element = init; element <= final; element += num) {
      let _array = state;
      _array.push(element);
      setState(_array);
    }
  };
  useEffect(() => {
    // 使用迴圈模組產生dropdown選項，並持續監聽是否更動數值
    createArray(0, 60, 1, arrbreath_high, setArrbreath_high);
    createArray(0, 60, 1, arrbreath_low, setArrbreath_low);
    createArray(40, 100, 5, arrHeart_high, setArrHeart_high);
    createArray(40, 100, 5, arrHeart_low, setArrHeart_low);
    createArray(0, 60, 15, arrlev_over, setArrlev_over);
    createArray(0, 12, 1, arrlong_sty, setArrlong_sty);
    createArray(0, 5, 1, arrrepeat, setArrrepeat);
    createArray(0, 20, 5, arrsit_up, setArrsit_up);
  }, [arrbreath_high, arrbreath_low, arrlev_over, arrlong_sty, arrHeart_high, arrHeart_low, arrsit_up, arrrepeat]);

  // ##### STEP2：取得頁面預設值 API_GET #####
  const mac = p !== undefined ? props.data.mac : ''; // 待props傳值
  const id = p !== undefined ? props.data.id : ''; // 待props傳值
  // 資料庫轉字串--靈敏度 alert_level_day / alert_level_mid / alert_level_night

  function num_text(value_from_data, setState) {
    switch (value_from_data) {
      case 0:
        setState(t('RESIDENTS_SETTING.SENSOR.OFF'));
        break;
      case 1:
        setState(t('RESIDENTS_SETTING.SENSOR.FIRST_NIB_STAGE'));
        break;
      case 2:
        setState(t('RESIDENTS_SETTING.SENSOR.FIRST_EXIT_STAGE'));
        break;
      case 3:
        setState(t('RESIDENTS_SETTING.SENSOR.FIRST_SIT_STAGE'));
        break;
      case 12:
        setState(t('RESIDENTS_SETTING.SENSOR.SECOND_12_STAGE'));
        break;
      case 13:
        setState(t('RESIDENTS_SETTING.SENSOR.SECOND_13_STAGE'));
        break;
      case 23:
        setState(t('RESIDENTS_SETTING.SENSOR.SECOND_23_STAGE'));
        break;
      case 123:
        setState(t('RESIDENTS_SETTING.SENSOR.THIRD_123_STAGE'));
        break;
      case 5:
        setState(t('RESIDENTS_SETTING.SENSOR.VOID'));
        setShowVoiceWarning(true);
        break;
      case 15:
        setState(t('RESIDENTS_SETTING.SENSOR.SMALL'));
        setShowVoiceWarning(true);
        break;
      case 20:
        setState(t('RESIDENTS_SETTING.SENSOR.MEDIUM'));
        setShowVoiceWarning(true);
        break;
      case 30:
        setState(t('RESIDENTS_SETTING.SENSOR.LARGE'));
        setShowVoiceWarning(true);
        break;
      case t('RESIDENTS_SETTING.SENSOR.OFF'):
        return 0;
      case t('RESIDENTS_SETTING.SENSOR.FIRST_NIB_STAGE'):
        return 1;
      case t('RESIDENTS_SETTING.SENSOR.FIRST_EXIT_STAGE'):
        return 2;
      case t('RESIDENTS_SETTING.SENSOR.FIRST_SIT_STAGE'):
        return 3;
      case t('RESIDENTS_SETTING.SENSOR.SECOND_12_STAGE'):
        return 12;
      case t('RESIDENTS_SETTING.SENSOR.SECOND_13_STAGE'):
        return 13;
      case t('RESIDENTS_SETTING.SENSOR.SECOND_23_STAGE'):
        return 23;
      case t('RESIDENTS_SETTING.SENSOR.THIRD_123_STAGE'):
        return 123;
      case t('RESIDENTS_SETTING.SENSOR.VOID'):
        return 5;
      case t('RESIDENTS_SETTING.SENSOR.SMALL'):
        return 15;
      case t('RESIDENTS_SETTING.SENSOR.MEDIUM'):
        return 20;
      case t('RESIDENTS_SETTING.SENSOR.LARGE'):
        return 30;
      default:
        return null;
    }
  }

  // 取得上一次整組參數設定資料，作為預設值
  function API_GET() {
    ApiGo.getMac_alert_setting(mac).then((fromMac) => {
      try {
        setLev_over(fromMac.leaving_overtime_day);
        setLeave_from(fromMac.leaving_overtime_from_time);
        setLeave_end(fromMac.leaving_overtime_to_time);
        setLong_sty(parseFloat((fromMac.long_stay_day / 60).toFixed(0)));
        num_text(fromMac.alert_level_day, setDay_period);
        num_text(fromMac.alert_level_mid, setNight_period);
        num_text(fromMac.alert_level_night, setMidnight_period);
        num_text(fromMac.volume_control, setVoiceWarning);
        setLong_sty_autotime(parseFloat((fromMac.long_stay_autotime / 60).toFixed(2)));
      } catch { }
    });
  }
  useEffect(() => {
    API_GET();
  }, [t]);

  // 因為是update所以不用比對前後資料，操作紀錄透過audit trail查看
  // API_PUT
  const API_PUT = () => {
    // 整理要put的資料
    const JSONdataPut = {
      first_name: p.first_name,
      last_name: p.last_name,
      alert_level_day: num_text(day_period),
      alert_level_mid: num_text(night_period),
      alert_level_night: num_text(midnight_period),
      leaving_overtime_from_time: leave_from,
      leaving_overtime_to_time: leave_end,
      leaving_overtime_day: lev_over,
      long_stay_day: long_sty * 60,
      breath_high: breath_high,
      breath_low: breath_low,
      heart_high: heart_high,
      heart_low: heart_low,
      volume_control: num_text(voiceWarning),
      long_stay_autotime: long_sty_autotime, // 從設定翻身時間來連動其他數值
      created_at: new Date().Format('yyyy-MM-ddThh:mm:ss.SZ'),
      updated_at: new Date().Format('yyyy-MM-ddThh:mm:ss.SZ'),
    };
    ApiGo.putUpdate_Mac_Alert_Setting(JSONdataPut, p.mac)
      .then((res) => {
        ApiGo.getBed().then((res) => {
          ApiGo.getResidents().then((res) => {
            dispatch(ADD_RESIDENTS_ARRAY(res));
          });
          dispatch(ADD_BEDS_ARRAY(res.beds) || []);
        });
      })
      .then(props.hide) // 完成確認後關閉彈出視窗
      .catch((err) => {
        console.log('FAILED', err);
      });
  };

  const time_convert = (value) => {
    let time_value = value.split(':');
    return time_value[0] + ':' + time_value[1];
  };

  useEffect(() => {
    ApiGo.getAll_mac_alert_setting()
      .then((res) => {
        setDay_start(time_convert(res[0].day_start_at));
        setMid_start(time_convert(res[0].mid_start_at));
        setNight_start(time_convert(res[0].night_start_at));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const settingsArray = [
    {
      label: t('RESIDENTS_SETTING.SENSOR.OUT_OF_BED_TOO_LONG_WARNING'),
      value: `${lev_over}${t('GLOBAL.UNIT.MINUTE')}`,
    },
    {
      label: t('RESIDENTS_SETTING.SENSOR.OUT_OF_BED_TOO_LONG_WARNING_TIME_PERIOD'),
      value: `${leave_from}-${leave_end}`,
    },
    {
      label: t('RESIDENTS_SETTING.SENSOR.LONG_LYING_WARNING'),
      value: `${long_sty}${t('GLOBAL.UNIT.HOURS')}`,
    },
    // {
    //   label: `${t('RESIDENTS_SETTING.SENSOR.RESPIRATORY_WARNING')}${t('RESIDENTS_SETTING.SENSOR.ABOVE')}`,
    //   value: `${breath_high}${t('GLOBAL.UNIT.TIMES')}`,
    // },
    // {
    //   label: `${t('RESIDENTS_SETTING.SENSOR.RESPIRATORY_WARNING')}${t('RESIDENTS_SETTING.SENSOR.BELOW')}`,
    //   value: `${breath_low}${t('GLOBAL.UNIT.TIMES')}`,
    // }
    {
      label: t('RESIDENTS_SETTING.SENSOR.DAY_SHIFT'),
      value: day_period,
    },
    {
      label: t('RESIDENTS_SETTING.SENSOR.NIGHT_SHIFT'),
      value: night_period,
    },
    {
      label: t('RESIDENTS_SETTING.SENSOR.GRAVEYARD_SHIFT'),
      value: midnight_period,
    },
    {
      label: t('RESIDENTS_SETTING.SENSOR.VOLUME'),
      value: voiceWarning === t('RESIDENTS_SETTING.SENSOR.OFF') ? t('RESIDENTS_SETTING.SENSOR.SILENCE') : voiceWarning,
    },
  ];

  if (isVital) {
    //開始位置, 要刪除幾個, 要插入的元素1, 要插入的元素2
    settingsArray.splice(
      3,
      0,
      {
        //呼吸警示多於
        //次
        label: `${t('RESIDENTS_SETTING.SENSOR.RESPIRATORY_WARNING')}${t('RESIDENTS_SETTING.SENSOR.ABOVE')}`,
        value: `${breath_high}${t('GLOBAL.UNIT.TIMES')}`,
      },
      {
        //呼吸警示低於
        //次
        label: `${t('RESIDENTS_SETTING.SENSOR.RESPIRATORY_WARNING')}${t('RESIDENTS_SETTING.SENSOR.BELOW')}`,
        value: `${breath_low}${t('GLOBAL.UNIT.TIMES')}`,
      }
    );
  }
  const txt = (
    <>
      <div className="w-100 fx-d-r fx-fsc mar-10">{t('RESIDENTS_SETTING.AUTO.PLEASE_CHECK_FOLLOWING_DATA_SETTINGS')}:</div>
      {settingsArray.map((setting, index) => (
        <div className="w-100 fx-d-r" key={index}>
          <div className={`w-80 fx-d-r fx-fsc`}>
            <div className="w-60 fx-fsc">{setting.label}</div>
            <div className="w-80 fx-fsc">{setting.value}</div>
          </div>
        </div>
      ))}
    </>
  );
  // pop 確認視窗
  const [pop, setPop] = useState({
    open: false,
    content: '',
    parameter: [],
  });
  function togglePop() {
    setPop({
      open: false,
      content: '',
      parameter: [],
    });
  }
  // pop 確認視窗
  return (
    <>
      {/* 資料過濾區塊 */}
      <UiIntegrater
        OnOff_switch={[false, false, false, true, true]}
        date={new Date()}
        // setReturnDate={setReturnDate}
        setReturnDate={() => { }}
        name={p !== undefined ? p.last_name : ''}
        bed={p !== undefined ? p.first_name : ''}
      />
      {/* Personal切版 */}
      <div className="wrap-sensor w-100 h-80" style={{ display: 'flex' }}>
        {pop.open ? <PopConfirm title={t('RESIDENTS_SETTING.RESIDENT_SETTING')} content={pop.content} hide={togglePop} callBack={API_PUT} parameter={pop.parameter} /> : null}
        <div className="w-100 h-100">
          {/* 第一排 */}
          <div className="h-10 flied">
            <div className="fx-ccc w-6 h-75 title_typeA">{t('RESIDENTS_SETTING.SENSOR.OUT_OF_BED_TOO_LONG_WARNING')}</div>
            <div className="fx-ccc w-6 h-75 content_input">
              <div className="dropdown-container">
                <REDropdown toggleDropdown={SwitchFunction} closeToggle={lev_overSwitch} data={{ id: 0, keys: arrlev_over, data: lev_over }} returnData={setLev_over} />
              </div>
              <div className="content-unit">{t('GLOBAL.UNIT.MINUTE')}</div>
            </div>
            <div className="fx-ccc w-6 h-75 title_typeA">{t('RESIDENTS_SETTING.SENSOR.OUT_OF_BED_TOO_LONG_WARNING_TIME_PERIOD')}</div>
            <div className="fx-ccc w-6 h-75 content_input">
              <div className="dropdown-container">
                {/* 09:00 */}
                <REDropdown toggleDropdown={SwitchFunction} closeToggle={leave_fromSwitch} data={{ id: 1, keys: ['20:00:00', '21:00:00', '22:00:00', '23:00:00'], data: leave_from }} returnData={setLeave_from} />
              </div>
            </div>
            <div className="fx-ccc w-6 h-75 markmark"> — </div>
            <div className="fx-ccc w-6 h-75 content_input">
              <div className="dropdown-container">
                {/* 17:00 */}
                <REDropdown toggleDropdown={SwitchFunction} closeToggle={leave_endSwitch} data={{ id: 2, keys: ['05:00:00', '06:00:00', '07:00:00', '08:00:00'], data: leave_end }} returnData={setLeave_end} />
              </div>
            </div>
          </div>
          {/* 第二排 */}
          <div className="h-10 flied"></div>
          {/* 第三排 久臥警示*/}
          <div className="h-10 flied">
            <div className="fx-ccc w-6 h-75 title_typeA">{t('RESIDENTS_SETTING.SENSOR.LONG_LYING_WARNING')}</div>
            <div className="fx-ccc w-6 h-75 content_input">
              <div className="dropdown-container">
                {/* 1HR */}
                <REDropdown toggleDropdown={SwitchFunction} closeToggle={long_stySwitch} data={{ id: 3, keys: arrlong_sty, data: long_sty }} returnData={setLong_sty} />
              </div>
              <div className="content-unit">{t('GLOBAL.UNIT.HOURS')}</div>
            </div>

            {/* 照護設定/呼吸警示 */}
            {
              isVital && isFdaClass !== 2 && (
                <>
                  <div className="fx-ccc w-6 h-75 title_typeA">{t('RESIDENTS_SETTING.SENSOR.RESPIRATORY_WARNING')}</div>
                  <div className="fx-ccc w-6 h-75 content_input">
                    <div className="content-unit">{t('RESIDENTS_SETTING.SENSOR.ABOVE')}</div>
                    <div className="dropdown-container">
                      {/* 1HR */}
                      <REDropdown toggleDropdown={SwitchFunction} closeToggle={breath_highSwitch} data={{ id: 4, keys: arrbreath_high, data: breath_high }} returnData={setBreath_high} />
                    </div>
                    <div className="content-unit">{t('GLOBAL.UNIT.TIMES')}</div>
                  </div>
                  <div className="fx-ccc w-6 h-75 markmark"> / </div>
                  <div className="fx-ccc w-6 h-75 content_input">
                    <div className="content-unit">{t('RESIDENTS_SETTING.SENSOR.BELOW')}</div>
                    <div className="dropdown-container">
                      <REDropdown toggleDropdown={SwitchFunction} closeToggle={breath_lowSwitch} data={{ id: 5, keys: arrbreath_low, data: breath_low }} returnData={setBreath_low} />
                    </div>
                    <div className="content-unit">{t('GLOBAL.UNIT.TIMES')}</div>
                  </div>
                </>
              )
            }
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-6 h-75"></div>
            <div className="fx-ccc w-6 h-75 "></div>
            {/* 照護設定/心跳警示 */}
            {ConfigHandler.isShowCF() ? (
              <>
                <div className="fx-ccc w-6 h-75 title_typeA">{t('RESIDENTS_SETTING.SENSOR.HEARTRATE_WARNING')}</div>
                <div className="fx-ccc w-6 h-75 content_input">
                  <div className="content-unit">{t('RESIDENTS_SETTING.SENSOR.ABOVE')}</div>
                  <div className="dropdown-container">
                    {/* 1HR */}
                    <REDropdown toggleDropdown={SwitchFunction} closeToggle={heart_highSwitch} data={{ id: 9, keys: arrHeart_high, data: heart_high }} returnData={setHeart_high} />
                  </div>
                  <div className="content-unit">{t('GLOBAL.UNIT.TIMES')}</div>
                </div>
                <div className="fx-ccc w-6 h-75 markmark"> / </div>
                <div className="fx-ccc w-6 h-75 content_input">
                  <div className="content-unit">{t('RESIDENTS_SETTING.SENSOR.BELOW')}</div>
                  <div className="dropdown-container">
                    <REDropdown toggleDropdown={SwitchFunction} closeToggle={heart_lowSwitch} data={{ id: 10, keys: arrHeart_low, data: heart_low }} returnData={setHeart_low} />
                  </div>
                  <div className="content-unit">{t('GLOBAL.UNIT.TIMES')}</div>
                </div>
              </>
            ) : null}
          </div>
          {/* 起床警告靈敏度 */}
          <div className="h-10 flied">
            <div className="fx-ccc w-6 h-75 title_typeC">{t('RESIDENTS_SETTING.SENSOR.OUT_OF_BED_WARNING_SENSITIVITY')}</div>
          </div>
          {/* 日班 */}
          <div className="h-10 flied">
            <div className="fx-ccc w-6 h-75 title_typeC">{t('RESIDENTS_SETTING.SENSOR.DAY_SHIFT')}</div>
            <div className="fx-ccc w-6 h-75 title_typeC">
              {day_start}-{mid_start}
            </div>
            <div className="fx-ccc w-6 h-75 content_input w-50">
              <div className="dropdown-container">
                <REDropdown toggleDropdown={SwitchFunction} closeToggle={day_periodSwitch} data={{ id: 6, keys: [t('RESIDENTS_SETTING.SENSOR.OFF'), t('RESIDENTS_SETTING.SENSOR.FIRST_NIB_STAGE'), t('RESIDENTS_SETTING.SENSOR.FIRST_EXIT_STAGE'), t('RESIDENTS_SETTING.SENSOR.FIRST_SIT_STAGE'), t('RESIDENTS_SETTING.SENSOR.SECOND_12_STAGE'), t('RESIDENTS_SETTING.SENSOR.SECOND_13_STAGE'), t('RESIDENTS_SETTING.SENSOR.SECOND_23_STAGE'), t('RESIDENTS_SETTING.SENSOR.THIRD_123_STAGE')], data: day_period }} returnData={setDay_period} />
              </div>
            </div>
          </div>
          {/* 夜班 */}
          <div className="h-10 flied">
            <div className="fx-ccc w-6 h-75 title_typeC">{t('RESIDENTS_SETTING.SENSOR.NIGHT_SHIFT')}</div>
            <div className="fx-ccc w-6 h-75 title_typeC">
              {mid_start}-{night_start === '00:00' ? '24:00' : night_start}
            </div>
            <div className="fx-ccc w-6 h-75 content_input w-50">
              <div className="dropdown-container">
                {/* 1HR */}
                <REDropdown toggleDropdown={SwitchFunction} closeToggle={night_periodSwitch} data={{ id: 7, keys: [t('RESIDENTS_SETTING.SENSOR.OFF'), t('RESIDENTS_SETTING.SENSOR.FIRST_NIB_STAGE'), t('RESIDENTS_SETTING.SENSOR.FIRST_EXIT_STAGE'), t('RESIDENTS_SETTING.SENSOR.FIRST_SIT_STAGE'), t('RESIDENTS_SETTING.SENSOR.SECOND_12_STAGE'), t('RESIDENTS_SETTING.SENSOR.SECOND_13_STAGE'), t('RESIDENTS_SETTING.SENSOR.SECOND_23_STAGE'), t('RESIDENTS_SETTING.SENSOR.THIRD_123_STAGE')], data: night_period }} returnData={setNight_period} />
              </div>
            </div>
          </div>
          {/* 大夜班 */}
          <div className="h-10 flied">
            <div className="fx-ccc w-6 h-75 title_typeC">{t('RESIDENTS_SETTING.SENSOR.GRAVEYARD_SHIFT')}</div>
            <div className="fx-ccc w-6 h-75 title_typeC">
              {night_start === '00:00' ? '24:00' : night_start}-{day_start}
            </div>
            <div className="fx-ccc w-6 h-75 content_input w-50">
              <div className="dropdown-container">
                {/* 2HR */}
                <REDropdown toggleDropdown={SwitchFunction} closeToggle={midnight_periodSwitch} data={{ id: 8, keys: [t('RESIDENTS_SETTING.SENSOR.OFF'), t('RESIDENTS_SETTING.SENSOR.FIRST_NIB_STAGE'), t('RESIDENTS_SETTING.SENSOR.FIRST_EXIT_STAGE'), t('RESIDENTS_SETTING.SENSOR.FIRST_SIT_STAGE'), t('RESIDENTS_SETTING.SENSOR.SECOND_12_STAGE'), t('RESIDENTS_SETTING.SENSOR.SECOND_13_STAGE'), t('RESIDENTS_SETTING.SENSOR.SECOND_23_STAGE'), t('RESIDENTS_SETTING.SENSOR.THIRD_123_STAGE')], data: midnight_period }} returnData={setMidnight_period} />
              </div>
            </div>
          </div>
          {/* 語音警告調整設定 */}
          {showVoiceWarning ? (
            <div className="h-10 flied mar-30 t">
              <div className="fx-ccc w-6 h-75 title_typeE">{t('RESIDENTS_SETTING.SENSOR.VOLUME')}</div>
              <div className="fx-ccc w-6 h-75 content_input">
                <div className="dropdown-container">
                  {/* 1HR */}
                  <REDropdown toggleDropdown={SwitchFunction} closeToggle={voiceWarningSwitch} data={{
                    id: 11,
                    keys: [t('RESIDENTS_SETTING.SENSOR.LARGE'),
                    t('RESIDENTS_SETTING.SENSOR.MEDIUM'),
                    t('RESIDENTS_SETTING.SENSOR.SMALL'),
                    ],
                    data: voiceWarning
                  }} returnData={setVoiceWarning} />
                </div>
              </div>
            </div>
          ) : (
            <div className="h-10 flied mar-30 t">
              <div className="fx-ccc w-6 h-75 title_typeE">{t('RESIDENTS_SETTING.SENSOR.VOLUME')}</div>
              <div className="fx-ccc w-6 h-75 content_input">
                <div className="dropdown-container">
                  {/* 1HR */}
                  <REDropdown showVoiceWarning={showVoiceWarning} toggleDropdown={SwitchFunction} closeToggle={voiceWarningSwitch} data={{
                    id: 11,
                    keys: [t('RESIDENTS_SETTING.SENSOR.LARGE'),
                    t('RESIDENTS_SETTING.SENSOR.MEDIUM'),
                    t('RESIDENTS_SETTING.SENSOR.SMALL'),
                    t('RESIDENTS_SETTING.SENSOR.VOID')],
                    data: voiceWarning
                  }} returnData={setVoiceWarning} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="wrap-sensor-btn w-100 h-10">
        <div className="h-100 r-s-container">
          <div className="h-100 flied">
            <div className="fx-ccc w-100"></div>
          </div>
        </div>
        <div className="h-100 l-s-container">
          <div className="h-100 flied">
            <div
              className="fx-ccc w-50 btn_type"
              onClick={() => {
                setPop({
                  open: true,
                  content: txt,
                  parameter: [],
                });
              }}>
              {t('GLOBAL.CONFIRM')}
            </div>
            <div className="fx-ccc w-50 btn_type" onClick={props.hide}>
              {t('GLOBAL.CANCEL')}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RESensor;
